import { type RefObject, useLayoutEffect, useRef, useState } from 'react';

export const useResizeObserver = (): {
  containerRef: RefObject<HTMLDivElement>;
  width: number;
  height: number;
} => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateDimensions = (entries?: ResizeObserverEntry[]) => {
      if (entries) {
        const { width, height } = entries[0]?.contentRect ?? {
          width: 0,
          height: 0,
        };
        setDimensions({ width, height });
      } else {
        const { width, height } = container.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };

    updateDimensions();

    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, []);

  return { containerRef, ...dimensions };
};
